export enum Step {
  CARD_CHOICE = 'cardChoice',
  PRODUCT_CHOICE = 'productChoice',
  CONSUMER_SEARCH = 'consumerSearch',
  // NOTE: Step.APPLICATION is used by all workflows; 'creditApplication' is thus rather too specific, but meh.
  APPLICATION = 'creditApplication',
  APPLICATION_2 = 'creditApplication2',
  ADD_ONS = 'addOns',
  REVIEW_TERMS = 'reviewTerms',

  PRESCREEN_OFFER = 'prescreenOffer',

  DSP_START = 'dspStart',

  BATCH_PRESCREEN_START = 'batchPrescreenStart',

  PREQUAL_OFFER_APPLICATION = 'prequalOfferApplication',
  PREQUAL_OFFER_PUSH_START = 'prequalOfferPushStart',

  MEMBERSHIP_VALIDATION = 'membershipValidation',

  DRIVER_LICENSE_START = 'driverLicenseStart',
  SCAN_PAGE = 'scanPage',
}

export interface Workflow {
  /**
   * Keys are steps in the workflow
   * Values are whether that particular step is enabled.
   */
  stepsEnabled: Partial<{ [key in Step]: boolean }>;
  /**
   * Map workflow steps to paths
   */
  paths: Partial<{ [step in Step]: string }>;
  /**
   * The first step in the progress bar
   */
  progressStartStep: Step | null;

  /**
   * The step to go to when restarting the workflow
   */
  restartStep: Step;

  /**
   * The step to go to when the app times out
   */
  timeoutRestartPath: string;
}
